import React, { Suspense, useEffect, useState } from "react";
import { HorizontalTeamStatsTable } from "./components/TeamStatsTable";
import PlayerStatsTable from "./components/PlayerStatsTable";
import RefreshButton from "./components/RefreshButton";
import { initStaticData } from "./utils/matchupUtils";
import useMatchupStore from "./store/MatchupStore";
import { useViewport } from "../components/hooks/useViewport";

function TeamToggle({ staticData }) {
  const [selectedTeam, setSelectedTeam] = useMatchupStore((state) => [
    state.selectedTeam,
    state.setSelectedTeam,
  ]);
  function handleToggle(team) {
    setSelectedTeam(team);
  }

  return (
    <div
      className="inline-flex w-full md:hidden rounded-md shadow-xs mx-auto max-w-full"
      role="group"
    >
      <button
        type="button"
        onClick={() => handleToggle("team1")}
        className={`px-4 py-2 w-1/2 text-sm font-medium border truncate ${
          selectedTeam === "team1"
            ? "bg-gray-100 text-black dark:bg-gray-700 dark:text-white sm:dark:hover:bg-gray-700"
            : "bg-white text-gray-900 bg-transparent dark:bg-gray-900 dark:text-gray-200 sm:dark:hover:bg-gray-800"
        } border-gray-300 rounded-s-lg sm:hover:bg-gray-100 hover:text-black dark:border-gray-700 dark:hover:text-white `}
      >
        {staticData.team1.teamSeason.seasonName}
      </button>
      <button
        type="button"
        onClick={() => handleToggle("team2")}
        className={`-ml-px px-4 py-2 w-1/2 text-sm font-medium border truncate ${
          selectedTeam === "team2"
            ? "bg-gray-100 text-black dark:bg-gray-700 dark:text-white sm:dark:hover:bg-gray-700"
            : "bg-white text-gray-900 bg-transparent dark:bg-gray-900 dark:text-gray-200 sm:dark:hover:bg-gray-800"
        } border-gray-300 rounded-e-lg sm:hover:bg-gray-100 hover:text-black dark:border-gray-700 dark:hover:text-white `}
      >
        {staticData.team2.teamSeason.seasonName}
      </button>
    </div>
  );
}

export default function MatchupView({ userId, env, staticData }) {
  const [lastRefreshed] = useMatchupStore((state) => [state.lastRefreshed]);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    initStaticData(staticData);
  }, [staticData]);

  useEffect(() => {
    // Uncomment to enable auto-refresh:
    // const intervalId = setInterval(refreshMatchupData, 30000); // 30 seconds
    // return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    // Small delay to ensure DOM is ready
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, 50);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  const isWide = useViewport(768);

  const animationStyle = {
    opacity: isLoaded ? 1 : 0,
    transform: isLoaded ? "translateY(0)" : "translateY(12px)",
    transition:
      "opacity 500ms cubic-bezier(0.4, 0, 0.2, 1), transform 500ms cubic-bezier(0.4, 0, 0.2, 1)",
  };

  const formattedLastRefresh = lastRefreshed
    ? lastRefreshed
        .toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
        })
        .replace(" ", "")
        .toLowerCase()
    : null;

  if (!isLoaded) {
    return null;
  }

  return (
    <>
      <Suspense
        fallback={
          <div className="flex items-center justify-center h-96">
            Matchup loading...
          </div>
        }
      >
        <div>
          {/*<MatchupHeader*/}
          {/*  team1={staticData.team1}*/}
          {/*  team2={staticData.team2}*/}
          {/*  team1Complete={6.5}*/}
          {/*  team1Progress={0.5}*/}
          {/*  team2Complete={7.0}*/}
          {/*  team2Progress={1.0}*/}
          {/*/>*/}
          <div className="mb-4 mt-4">
            <div className="-mx-4 md:-mx-2">
              <HorizontalTeamStatsTable formula={staticData.formula} />
            </div>
          </div>

          <div className="mb-2 -ml-2 -mr-1.5 flex items-center justify-between md:justify-end gap-2.5">
            {/*<div className="flex items-center">*/}
            {/*  <button*/}
            {/*    id="statsButton"*/}
            {/*    data-dropdown-toggle="statsDropdown"*/}
            {/*    type="button"*/}
            {/*    className="me-2 inline-flex items-center whitespace-nowrap rounded-full border border-gray-300 bg-white px-3 py-1 text-sm font-medium text-gray-900 transition-colors hover:border-primary-500 focus:border-primary-500 focus:outline-none focus:ring-2 focus:ring-gray-100 sm:px-4 sm:py-2 dark:border-gray-600 dark:bg-transparent dark:text-white dark:hover:border-gray-400 dark:hover:bg-gray-800 dark:focus:border-gray-400 dark:focus:bg-gray-800 dark:focus:ring-transparent"*/}
            {/*  >*/}
            {/*    By Position*/}
            {/*    <svg*/}
            {/*      className="ms-3 h-2.5 w-2.5"*/}
            {/*      aria-hidden="true"*/}
            {/*      xmlns="http://www.w3.org/2000/svg"*/}
            {/*      fill="none"*/}
            {/*      viewBox="0 0 10 6"*/}
            {/*    >*/}
            {/*      <path*/}
            {/*        stroke="currentColor"*/}
            {/*        strokeLinecap="round"*/}
            {/*        strokeLinejoin="round"*/}
            {/*        strokeWidth="2"*/}
            {/*        d="m1 1 4 4 4-4"*/}
            {/*      ></path>*/}
            {/*    </svg>*/}
            {/*  </button>*/}

            {/*  <div*/}
            {/*    id="statsDropdown"*/}
            {/*    className="z-50 hidden w-44 divide-y divide-gray-100 rounded-lg bg-white shadow dark:bg-gray-700"*/}
            {/*  >*/}
            {/*    <ul*/}
            {/*      className="py-2 text-md text-gray-700 dark:text-gray-200"*/}
            {/*      aria-labelledby="statsButton"*/}
            {/*    >*/}
            {/*      <li>*/}
            {/*        <a*/}
            {/*          href="?stats=SA"*/}
            {/*          className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white bg-gray-200 dark:bg-gray-600"*/}
            {/*        >*/}
            {/*          By Position*/}
            {/*        </a>*/}
            {/*      </li>*/}
            {/*      <li>*/}
            {/*        <a*/}
            {/*          href="?stats=EXP"*/}
            {/*          className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white "*/}
            {/*        >*/}
            {/*          By Game Time*/}
            {/*        </a>*/}
            {/*      </li>*/}
            {/*    </ul>*/}
            {/*  </div>*/}
            {/*  <a*/}
            {/*    data-turbo="true"*/}
            {/*    data-turbo-frame="modal"*/}
            {/*    href="/plus"*/}
            {/*    className="h4 mb-0 inline-flex items-center justify-center rounded-2xl border border-gray-300 bg-white px-2.5 py-1.5 text-center text-xs font-medium text-gray-900 hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700 dark:focus:ring-gray-800"*/}
            {/*  >*/}
            {/*    <span className="h-3.5 w-3.5 -my-px sm:h-3.5 sm:w-3.5">*/}
            {/*      <svg*/}
            {/*        className="h-full w-full text-teal-400 dark:text-teal-400"*/}
            {/*        viewBox="0 0 108 108"*/}
            {/*        fill="none"*/}
            {/*        xmlns="http://www.w3.org/2000/svg"*/}
            {/*      >*/}
            {/*        <path*/}
            {/*          d="M54 4C54 31.6142 76.3856 54 104 54C76.3856 54 54 76.3856 54 104C54 76.3856 31.6142 54 4 54C31.6142 54 54 31.6142 54 4Z"*/}
            {/*          fill="currentColor"*/}
            {/*          stroke="currentColor"*/}
            {/*          strokeWidth="8"*/}
            {/*          strokeLinecap="round"*/}
            {/*          strokeLinejoin="round"*/}
            {/*        ></path>*/}
            {/*      </svg>*/}
            {/*    </span>*/}
            {/*  </a>*/}
            {/*</div>*/}
            {/*<h2 className="h4 mb-0 {{ leagueSeason.points ? 'hidden' }} sm:inline">*/}
            {/*  Starters*/}
            {/*</h2>*/}
            {/*<div className="flex items-center gap-2">*/}
            {/*  {formattedLastRefresh && (*/}
            {/*    <span className="text-xs text-gray-500 dark:text-gray-400">*/}
            {/*      Last: {formattedLastRefresh}*/}
            {/*    </span>*/}
            {/*  )}*/}
            {/*  <RefreshButton />*/}
            {/*</div>*/}
            <TeamToggle staticData={staticData} />
            <RefreshButton />
          </div>

          <div className="-mx-4 md:-mx-2">
            <PlayerStatsTable staticData={staticData} />
          </div>
        </div>
      </Suspense>
    </>
  );
}
